import React from "react";
import DashboardMain from "../components/Dashboard/DashboardMain";
const Home = () => {

  return (
    <section className="h-full overflow-y-auto overflow-x-hidden bg-background-grey p-3 sm:p-4 noScroll">
      <DashboardMain />
    </section>
  );
};

export default Home;
